export default {"src":"/_next/static/media/Tuscany.1845e276.svg","height":155,"width":255,"blurWidth":0,"blurHeight":0};